<section class="content">
    <div class="text-end mb-2">
        <button type="button" class="btn btn-primary" (click)="createUser()">Create User</button>
    </div>

    <ag-grid-angular *ngIf="users.length > 0"
        class="ag-theme-alpine"
        [rowData]="users"
        [domLayout]="'autoHeight'"
        [animateRows]="true"
        [pagination]="true"
        [columnDefs]="colDefs"
        [gridOptions]="userGridOptions"
    >
    </ag-grid-angular>

    <div *ngIf="user?.firstName && user.firstName !=''" class="mt-5">
        <div>
            <h4 class="d-inline">{{user.firstName}} {{user.lastName}} ({{user.email}})</h4>
            <button type="button" class="btn btn-primary ms-5" (click)="edit(user)">Edit User</button>
            <button *ngIf="user?.externalId != null && user?.externalId != ''" type="button" class="btn btn-primary ms-5" (click)="refresh(user)">Refresh External Data</button>
        </div>
        <hr />
        <div>
            <div *ngFor="let project of user.projects">
                <div><h5>{{project.projectName}}</h5></div>
                <div>
                    <label class="form-label">Project Roles</label>
                    <input type=text class="form-control" [(ngModel)]="project.roles"/>
                </div>
            </div>
            <button class="btn btn-primary mt-3" (click)="updatePermissions()">Update</button>
        </div>
    </div>
</section>
